import { bool, exact, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const userAssignmentRuleType = exact({
  userId: string.isRequired,
  exclude: bool.isRequired,
  createdAt: string.isRequired,
  createdBy: string.isRequired,
  updatedAt: string,
  updatedBy: string,
});
